import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import settings from 'settings';
import THEME_KEY from 'reducers/theme.keys';
import REDUCER_KEY from 'reducers/reducer.keys';
import { AddTags, Inner } from 'components/Page';
import { list } from 'actions';
import config from './config';

/*
 ** @description Prepare data for api
 ** @param props Object user, duration, type, status, start_datetime, end_datetime
 ** @return data object
 */
const handlePrepareData = ({
  user, duration, type, status, start_datetime, end_datetime, is_integration_managed
}) => {
  if (is_integration_managed) return null;
  return ({
    user,
    duration,
    type_id: type.key,
    status_id: status.key,
    start_datetime,
    end_datetime
  });
};

const mapDispatchToProps = dispatch => ({
  loadTags(id) {
    return dispatch(list(
      REDUCER_KEY.themes.key,
      {
        page: 0,
        pageSize: settings.APP_CONFIG.dropListSize,
        filters: [{
          id: 'model',
          value: 'userleave'
        }],
        sorted: [{
          id: 'model',
          desc: false
        }]
      }
    ))
      .then((response) => {
        const page = 0;
        const pageSize = settings.APP_CONFIG.dropListSize;
        const sorted = [{
          id: 'name',
          desc: false
        }];
        const filters = [
          {
            id: 'theme',
            value: response.results[0].id
          },
          {
            id: 'object_id',
            value: id
          }
        ];
        return dispatch(list(REDUCER_KEY.itemTags.key, {
          page,
          pageSize,
          filters,
          sorted
        }));
      });
  }
});

const AvailabilityLeave = ({
  canAdmin, loadTags, objectId, onProcessTags, permissions
}) => {
  /*
   ** @description Do some post processing for the Tags
   ** @param data Object user, duration, type, status, start_datetime, end_datetime, tags
   ** @param
   ** @return data object
   */
  const handleSuccess = (response, data, original, callback) => {
    const { itemTags: tags } = data; // get the tags and object_id
    const { itemTags: originalTags } = original;
    const taggedObjectId = response ? response.id : original.id;
    // only process valid records
    if (taggedObjectId > -1) {
      onProcessTags(THEME_KEY.userleave, taggedObjectId, tags, originalTags)
        .finally(
          () => {
            callback(); // execute the succesfull callback
          }
        );
    }
  };
  return (
    <Inner
      classes="bhp-userleave"
      canAdmin={canAdmin && permissions.CanAdminAvailabilities()
        .hasPermissions()}
      reducer={{
        item: REDUCER_KEY.availabilityLeave,
        list: REDUCER_KEY.availabilityLeaveList,
        extra: REDUCER_KEY.itemTags
      }}
      config={{
        ...config,
        list: {
          ...config.list,
          filters: {
            user__id: [objectId]
          }
        },
        detail: {
          ...config.detail,
          parent: {
            user: objectId
          }
        }
      }}
      defaultSize="280px"
      onLoadItem={loadTags}
      onPrepareData={handlePrepareData}
      onSuccessCallback={handleSuccess}
      scroll={{
        x: 800,
        y: '100%'
      }}
      messaging={{
        delete: {
          disabled: () => 'Item Disabled.',
          failure: error => `Delete Failed. ${error}`,
          success: () => 'Delete Successful.'
        },
        save: {
          failure: () => 'Saving failed',
          success: () => 'Saving was successful'
        }
      }}
      themeName="userleave"
    />
  );
};

AvailabilityLeave.propTypes = {
  canAdmin: PropTypes.bool,
  loadTags: PropTypes.func,
  objectId: PropTypes.number,
  onProcessTags: PropTypes.func,
  permissions: PropTypes.object.isRequired
};

AvailabilityLeave.defaultProps = {
  canAdmin: true,
  loadTags() {
  },
  objectId: null,
  onProcessTags() {
  }
};

const Leave = AddTags(AvailabilityLeave);

export default connect(null, mapDispatchToProps)(Leave);
